import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promo-create',
  templateUrl: './promo-create.component.html',
  styleUrls: ['./promo-create.component.scss']
})
export class PromoCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/promos/promo-create/promo-create.component.ts